module.exports = __webpack_public_path__ + "media/images/emblems/Egg-blazon-variant-c5b9264c498bd935d4eabc6f9210bc0b.svg";